<style lang="less" scoped>
    .stock-picker{
        display: inline-block;
        vertical-align: middle;
        /deep/ .button {
            padding-left: 7px;
            padding-right: 7px;
        }
    }
    .stock{
        margin-bottom: 5px;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>
<template>
    <div class="stock-picker">
        <Poptip transfer width="250" :placement="placement" @on-popper-show="popShow">
            <div>
                <slot></slot>
            </div>
            <div slot="content">
                <i-input size="small" v-model="params.search" @on-enter="search" placeholder="搜索存货...">
                    <Button slot="append" icon="ios-search" @click="search" :loading="loading"></Button>
                </i-input>
                <div class="hr"></div>
                <Button long size="small" class="stock" v-for="stock in stocks" @click="selectStock(stock)" :key="stock.id">
                    <span>{{stock.uid}} - </span>
                    <span>{{stock.name}}</span>
                </Button>
            </div>
        </Poptip>
    </div>
</template>
<script>
    export default {
        props: {
            placement: {
                type: String,
                default: 'bottom'
            }
        },
        data(){
            return {
                params: {
                    search: '',
                    page: 1,
                    per_page: 10
                },
                stocks: [],
                loading: false
            }
        },
        computed: {
            //
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            popShow() {
                if (this.stocks.length === 0) {
                    this.search();
                }
            },
            search(){
                this.loading = true;
                Util.ajax.get(Util.api.es_query_stock, {
                    params: this.params
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    this.loading = false;
                    this.stocks = [];
                    if(res.code === 1){
                        let data = res.data;
                        this.stocks = data.stocks;
                        if(this.stocks.length === 0){
                            this.$Message.warning('未搜索到相关存货');
                        }
                    }else{
                        this.$Modal.error({
                            title: '错误',
                            content: res.msg
                        });
                    }
                }).catch((e)=>{
                    this.loading = false;
                    this.$Modal.error({
                        title: '错误',
                        content: e.message
                    });
                });
            },
            selectStock(stock){
                this.$emit('select', stock);
                document.body.click();
            }
        }
    }
</script>
